var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIconSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.629 18.472L11.087 19.388C10.604 20.204 9.397 20.204 8.913 19.388L8.371 18.472C7.951 17.762 7.741 17.406 7.403 17.21C7.065 17.013 6.64 17.006 5.79 16.991C4.534 16.97 3.747 16.893 3.087 16.619C2.48037 16.3677 1.92917 15.9994 1.46487 15.5351C1.00057 15.0708 0.632274 14.5196 0.381 13.913C2.98023e-08 12.995 0 11.83 0 9.5V8.5C0 5.227 0 3.59 0.737 2.388C1.14904 1.7152 1.71445 1.14945 2.387 0.737C3.59 0 5.228 0 8.5 0H11.5C14.773 0 16.41 0 17.613 0.737C18.2854 1.14917 18.8508 1.71456 19.263 2.387C20 3.59 20 5.228 20 8.5V9.5C20 11.83 20 12.995 19.62 13.913C19.3686 14.5197 19.0002 15.071 18.5357 15.5353C18.0712 15.9996 17.5198 16.3678 16.913 16.619C16.253 16.893 15.466 16.969 14.21 16.991C13.36 17.006 12.935 17.013 12.597 17.21C12.259 17.406 12.049 17.761 11.629 18.472Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconSelected);
export default __webpack_public_path__ + "static/media/MessageIconSelected.9fa11e35b734a55598528f9fffb5d142.svg";
export { ForwardRef as ReactComponent };